// Shared crop rendering so the admin preview and the public site match exactly.
export function attorneyImgStyle(attorney) {
  const position = attorney?.imagePosition || "center top";
  const zoom = attorney?.imageZoom || 1;
  return {
    objectPosition: position,
    transform: `scale(${zoom})`,
    transformOrigin: position,
  };
}
